// extracted by mini-css-extract-plugin
export default {"base":"BgjXW","icon":"WtS16"};